<template>
  <div>

    <header>
      <div id="maincontainer">

        <!-- left -->
        <div id="leftcolumn" @click="goTo('/')">{{appName}}</div>

        <!-- right -->
        <div id="contentwrapper">
          <!-- auth -->
          <span class="user-display-name">
            <!-- user | logout -->
            <span v-if="isLoggedIn">
              <span @click="goTo('/UserDetails')">{{user.displayName}}</span>
              <span> | </span>
              <span @click="logout">Logout</span>
            </span>
            <!-- login | signup -->
            <span v-else>
              <span @click="goTo('/Login')">Login</span>
              <span> | </span>
              <span @click="goTo('/Signup')">Signup</span>
            </span>
          </span>
        </div>

      </div>
    </header>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {mapMutations} from 'vuex'
  //
  export default {
    computed:{
      ...mapGetters([
        'user',
        'isLoggedIn',
        'appName'
      ])
    },
    methods:{
      ...mapMutations([
        'logout',
        'goTo'
      ])
    },
    created(){
      window.thisOfHeader = this
    }
  }
</script>

<style scoped>
  #maincontainer {
    width:100%;
    height: 100%;
  }

  #leftcolumn {
    float:left;
    display:inline-block;
    width: 100px;
    height: 100%;
    /*background: blue;*/
  }

  #contentwrapper {
    float:left;
    display:inline-block;
    width: -moz-calc(100% - 100px);
    width: -webkit-calc(100% - 100px);
    width: calc(100% - 100px);
    height: 100%;
    /*background-color: red;*/
  }

  .user-display-name{
    float: right;
  }
</style>



// WEBPACK FOOTER //
// header.vue?472d871d